function Dhexmare(){
    return (
        <div className="Haye_dhexmare">
            <div className="dhexmare">
            </div>
        </div>
    )
}

export default Dhexmare